const testimonials = [
  {
    name: "阿柚",
    role: "逆后宫爱好者",
    content: "在女神动漫按「逆后宫」一筛，一下就找到好几部对味的作品，入坑进度飞快。",
  },
  {
    name: "晚风",
    role: "高甜日常党",
    content: "追番时间表太好用了，每周更新都记得清清楚楚，再也没漏过一集。",
  },
  {
    name: "小鹿",
    role: "暧昧攻略迷",
    content: "专题攻略讲得很细，从暧昧名场面到嗑糖姿势，看完立刻上头的程度。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <p className="mb-2 text-xs font-bold tracking-widest text-primary-600">关于本站</p>
            <h2 className="font-display text-2xl text-foreground-950 md:text-4xl">
              为每个爱嗑恋爱番的你而建
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              女神动漫是一个专注后宫、恋爱、暧昧、攻略与逆后宫题材的动漫推荐专区。
              我们相信每一部好作品都值得被看见，也希望帮你把挑选的时间留给真正对味的剧情。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们的内容原则是：只推荐有剧情、有人设、有口碑的恋爱番；坚持标签清晰、分类明确，让你一搜即达；
              并且保持每季更新，让追更这件事变得简单又快乐。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {[
                { icon: "ri-heart-3-line", title: "精选推荐", desc: "层层筛选的好作品" },
                { icon: "ri-filter-3-line", title: "标签筛选", desc: "一按定位合口味" },
                { icon: "ri-refresh-line", title: "持续更新", desc: "每季追番不迷路" },
              ].map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg bg-background-100 p-4"
                >
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <p className="mt-3 font-display text-sm text-foreground-950">{item.title}</p>
                  <p className="mt-1 text-xs text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-lg bg-background-100 p-5">
                <div className="flex items-center gap-1 text-amber-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.content}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 text-sm font-bold text-white">
                    {t.name[0]}
                  </span>
                  <span>
                    <span className="block text-sm font-bold text-foreground-950">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}